export const getDeviceStore = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(userAgent)) return true;
  else return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  // iOS detection from: http://stackoverflow.com/a/9039885/177710
};
